<template>
  <div class="lead-status">
    <span class="lead-status-name">{{ lead_status }}</span>
  </div>
</template>

<script>
export default {
  name: "LeadStatus",
  props: {
    lead_status: String,
  },
};
</script>
<style>
.lead-status {
  display: flex;
  align-items: center;
}
.lead-status-img {
  width: 22.5px;
  height: 22.5px;
  border-radius: 50%;
  align-items: center;
}
</style>
